import React from 'react';

import { Icon } from '@/components/_atoms/Icon';
import { Typography } from '@/components/_atoms/Typography';

import { Modal, ModalContent, useModal } from '../Modal';
import { Tooltip } from '../Tooltip';

import { ProductSoldModal } from './ProductSoldModal';

interface Props {
  sold: number;
  product?: {
    tread: string;
    producer: string;
    sku: string;
    productionYear?: string;
    attributes?: {
      size: string;
      loadIndex: string;
      speedIndex: string;
    };
  };
}

export const ProductSold = (props: Props) => {
  const { sold, product } = props;
  const modal = useModal();
  const onClick = () => {
    if (product?.sku) {
      modal.open();
    }
  };
  return (
    <>
      <Tooltip
        asChild
        content={
          <Typography
            as="span"
            variant="body_s"
            color="white"
            id="productBox.sold.tooltip"
            values={{
              sold,
            }}
          />
        }
      >
        <button className={'inline-flex'} onClick={onClick}>
          <Typography
            as="span"
            id="productBox.sold.text"
            variant="body_s"
            values={{
              sold,
            }}
          />
          <Icon name="info" size={16} className="ml-1" />
        </button>
      </Tooltip>
      {product ? (
        <Modal isOpen={modal.isOpen} onOpenChange={modal.setIsOpen}>
          <ModalContent>
            <ProductSoldModal sold={sold} product={product} close={modal.close} />
          </ModalContent>
        </Modal>
      ) : null}
    </>
  );
};
